import {
  Answer,
  checkConditions,
  renderConditions,
  SupplementalFormType,
} from '@verifiedit/form-generator'

export function getValidSupplementalFormsToAdd(
  supplementalForms: SupplementalFormType[],
  answers: Map<string, Answer>,
): SupplementalFormType[] {
  const supplementalFormsToAdd = new Set<SupplementalFormType>()
  supplementalForms.forEach((supplemental) => {
    if (Object.prototype.hasOwnProperty.call(supplemental, 'conditions')) {
      const results = checkConditions(
        supplemental.conditions as renderConditions[],
        answers,
      )
      for (const result of Object.values(results)) {
        if (result.value) {
          supplementalFormsToAdd.add(supplemental)
        }
      }
    } else {
      supplementalFormsToAdd.add(supplemental)
    }
  })

  return Array.from(supplementalFormsToAdd)
}
